'use client';

import React from 'react';
import { formatDate } from '../../utils/dateFormatting';
import reportError from '../../utils/logger';
interface FormattedDateProps {
  date: string;
}

const FormattedDate: React.FC<FormattedDateProps> = ({ date }) => {
  try {
    return formatDate(date);
  } catch (error) {
    reportError('FormattedDate', error);
    return ''
  }

};

export default FormattedDate;
